module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse3-e6c89acf.svg";